import { useCallback, useEffect, useReducer, useState } from "react";
import styled from "styled-components";

type Props = {}

const DATA: string[] = [
    '“Karolcia”',
    '“Niesamowite przygody dziesięciu skarpetek (czterech prawych i sześciu lewych)”',
    '“O psie, który jeździł koleją”',
    '“Akademia Pana Kleksa”',
    '“Opowieści z Narnii. Lew, czarownica i stara szafa”',
    '“W pustyni i w puszczy “',
    '“Pinokio”',
    '“Kopciuszek”',
    '“Ania z Zielonego Wzgórza”',
    '“Harry Potter i Komnata Tajemnic”',
    '“Chatka Puchatka”',
    '“Alicja w Krainie Czarów”',
    '“Tajemniczy Ogród”',
    '“Mały Książę”',
    '“Król Maciuś Pierwszy”',
    '“Hania Humorek”',
    '“Muminki”',
    '“Piotruś Pan”',
    '“Szatan z siódmej klasy”',
    '“Charlie i fabryka czekolady”',
].sort(() => (Math.random() - .5));

const TextContainer = styled.div``;

const Task404Game: React.FC<Props> = () => {

    const [openned, incOpen] = useReducer((state) => {
        return (state + 1) % DATA.length;
    }, 0);

    const [mode, setMode] = useState<'rotating' | 'setting' | 'stale'>('rotating');

    const onRandomizeClick = useCallback(() => {
        setMode('setting');

        setTimeout(() => {
            setMode('stale');
        }, 1000);
    }, [setMode]);

    const onResetClick = useCallback(() => {
        setMode('rotating');
    }, [setMode]);

    useEffect(() => {
        if (mode === 'rotating' || mode === 'setting') {
            const id = setInterval(() => {
                incOpen();
            }, 100);

            return () => {
                clearInterval(id);
            }
        }
    }, [incOpen, mode]);

    return <div className="task-404-game">
        <div className={`window ${mode}`}>
            {DATA.map((text, index) => {
                return <TextContainer className={`text ${openned === index ? 'showed' : 'hidden'}`} key={index}>
                    {text}
                </TextContainer>
            })}
        </div>
        <div className="buttons">
            {mode === 'rotating' && <button onClick={onRandomizeClick}>Losuj</button>}
            {mode === 'stale' && <button onClick={onResetClick}>Od nowa</button>}
        </div>
    </div>
};

export default Task404Game;
